import { useMutation } from "@tanstack/react-query";

import { useCurrentCompanyId } from "@/hooks/useCurrentCompanyId";
import { useCurrentJobId } from "@/hooks/useCurrentJobId";
import { useCelebrateStafferPetAward } from "@/hooks/useStafferPets";
import { guacHttpClient } from "@/lib/http";
import {
  CandidacyStatus,
  HttpError,
  HttpResponse,
  MoveCandidacyRequest,
  UpdateCandidacyResponse,
} from "@/types";

export function useMoveCandidacy() {
  const celebrateStafferPetAward = useCelebrateStafferPetAward();
  const currentCompanyId = useCurrentCompanyId();
  const currentJobId = useCurrentJobId();

  return useMutation<
    UpdateCandidacyResponse,
    HttpError<{ message?: string }>,
    {
      candidacyId: string;
      fromStatus: CandidacyStatus;
      moveCandidacyRequest: MoveCandidacyRequest;
    }
  >({
    mutationFn: async ({ candidacyId, moveCandidacyRequest }) => {
      const path = `companies/${currentCompanyId}/jobs/${currentJobId}/candidacies/${candidacyId}/move-candidacy`;
      const res = await guacHttpClient.post<
        UpdateCandidacyResponse,
        HttpResponse<UpdateCandidacyResponse>,
        MoveCandidacyRequest
      >(path, moveCandidacyRequest);

      return res.data;
    },
    onSuccess: (data) => {
      // A submit coin, when guac awarded one for this move.
      celebrateStafferPetAward(data.stafferPetAward);
    },
  });
}
